import { render, staticRenderFns } from "./AllTeam.vue?vue&type=template&id=6a56f057&scoped=true&"
import script from "./AllTeam.vue?vue&type=script&lang=js&"
export * from "./AllTeam.vue?vue&type=script&lang=js&"
import style0 from "./AllTeam.vue?vue&type=style&index=0&id=6a56f057&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a56f057",
  null
  
)

export default component.exports